/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PortfolioDto } from '../../models/portfolio-dto';

export interface PortfolioAdminControllerFindByIdV1$Params {
  id: string;
}

export function portfolioAdminControllerFindByIdV1(http: HttpClient, rootUrl: string, params: PortfolioAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PortfolioDto>> {
  const rb = new RequestBuilder(rootUrl, portfolioAdminControllerFindByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PortfolioDto>;
    })
  );
}

portfolioAdminControllerFindByIdV1.PATH = '/api/v1/portfolios/admin/{id}';
